import * as React from "react";

interface Props extends React.PropsWithChildren {
  className?: string;
  columnCount: number;
  hasRemoveButton?: boolean;
}
export const FormListFieldItem: React.FC<Props> = ({ className = "", columnCount, hasRemoveButton, children }) => {
  return (
    <>
      <div
        className={`gap-2 ${className}`}
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${columnCount}, 1fr) ${hasRemoveButton ? "32px" : ""}`,
        }}
      >
        {children}
      </div>
    </>
  );
};
